import { Component, inject, ChangeDetectionStrategy, signal, output } from '@angular/core';
import {PerformanceDefaultsService} from "../../services/performance-defaults.service";
import {PerformanceDefaults} from "../../model/performance-defaults";
import {UserPerformanceDefaults} from "../../model/user-performance-defaults";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

import {PerformanceDefaultsComponent} from "../performance-defaults/performance-defaults.component";

@Component({
    selector: 'app-user-performance-defaults',
    imports: [
    MatProgressSpinner,
    PerformanceDefaultsComponent
],
    templateUrl: './user-performance-defaults.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './user-performance-defaults.component.css'
})
export class UserPerformanceDefaultsComponent {
  private readonly defaultsService = inject(PerformanceDefaultsService);


  readonly errorEvent = output<any>();
  readonly userPerformanceDefaults = signal<UserPerformanceDefaults>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);

  ngOnInit(): void {
    this.isBusy.set(true);
    this.defaultsService.getUserDefaults().subscribe({
      next: (defaults: UserPerformanceDefaults) => {
        this.userPerformanceDefaults.set(defaults);
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorEvent.emit(error);
  }

  performanceDefaultUpdated(defaults: PerformanceDefaults): void {
    this.isBusy.set(true);
    this.userPerformanceDefaults().performanceDefaults = defaults;
    this.defaultsService.saveUserDefaults(this.userPerformanceDefaults()).subscribe({
      next: (updated: UserPerformanceDefaults) => {
        this.userPerformanceDefaults.set(updated);
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

}
